import { inject, observer } from "mobx-react";
import React from "react";
import Dialog from "@material-ui/core/Dialog";

class VideoPlayer extends React.Component {
  render() {
    const { videoPlayerStore } = this.props;

    return (
      <Dialog
        onClose={() => videoPlayerStore.hidePlayer()}
        open={videoPlayerStore.isOpen}
        maxWidth={false}
      >
        <video
          src={videoPlayerStore.videoSrc}
          width="960px"
          height="540px"
          type="video/mp4"
          autoPlay
          controls
          controlsList={
            videoPlayerStore.isVideoDownloadable ? "" : "nodownload"
          }
        />
      </Dialog>
    );
  }
}

export default inject("videoPlayerStore")(observer(VideoPlayer));



// WEBPACK FOOTER //
// ./src/components/VideoPlayer.js